// extracted by mini-css-extract-plugin
export default {"container":"Photos_container__d9VXv"};